export default __webpack_public_path__ + "static/media/translations.41cb6f74.csv";